import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { RootState } from 'app/redux/store';

import { MenuState } from '../types';

const initialState: MenuState = {
  isOpened: false,
  currentPathname: null,
  backPathname: '',
  currentDashboard: null,
};

const menuSlice = createSlice({
  name: 'menu',
  initialState,
  reducers: {
    setMenuOpenedAction(state, action: PayloadAction<boolean>) {
      state.isOpened = action.payload;
    },

    setCurrentPathnameAction(state, action: PayloadAction<string | null>) {
      state.currentPathname = action.payload;
    },

    setBackPathnameAction(state, action: PayloadAction<string>) {
      state.backPathname = action.payload;
    },

    setCurrentDashboardAction(state, action: PayloadAction<string | null>) {
      state.currentDashboard = action.payload;
    },
  },
});

export const { setMenuOpenedAction, setCurrentPathnameAction, setBackPathnameAction, setCurrentDashboardAction } = menuSlice.actions;

export const getMenu = (state: RootState): MenuState => state.menu;

export default menuSlice.reducer;
